import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { navItems } from "src/app/layouts/full/vertical/sidebar/sidebar-data";
import { MaterialModule } from 'src/app/material.module';

@Component({
    selector: 'search-dialog',
    standalone: true,
    imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
    templateUrl: 'search-dialog.component.html',
  })
  export class AppSearchDialogComponent {
    searchText: string = '';
    navItems = navItems;
  
    navItemsData = navItems.filter((navitem) => navitem.displayName);
  }